<script setup lang="ts">
defineExpose({
  name: "SortDefaultIcon",
});
</script>

<template>
  <svg
    class="SortDefaultIcon"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_2046_23"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_2046_23)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 3L5 10H19L12 3ZM15.375 8.5H8.625L12 5.125L15.375 8.5ZM12 21L19 14H5L12 21ZM12 19L15.375 15.5H8.625L12 19Z"
      />
    </g>
  </svg>
</template>

<style lang="scss" scoped>
.SortDefaultIcon {
  width: 100%;
  height: auto;
  fill: currentcolor;
}
</style>
